import {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
  PropsWithChildren,
} from 'react';
import { useLocation } from 'react-router-dom';

type NavigationHistory = {
  previousPathname: string | null;
};

const NavigationHistoryContext = createContext<NavigationHistory>({
  previousPathname: null,
});

export const NavigationContextProvider = ({ children }: PropsWithChildren) => {
  const location = useLocation();
  const previousPathnameRef = useRef<string | null>(null);
  const currentPathnameRef = useRef<string | null>(null);
  const [previousPathname, setPreviousPathname] = useState<string | null>(null);

  useEffect(() => {
    if (location.pathname === currentPathnameRef.current) return;

    previousPathnameRef.current = currentPathnameRef.current;
    currentPathnameRef.current = location.pathname;
    setPreviousPathname(previousPathnameRef.current);
  }, [location.pathname]);

  return (
    <NavigationHistoryContext.Provider value={{ previousPathname }}>
      {children}
    </NavigationHistoryContext.Provider>
  );
};

export const useNavigationContext = () => useContext(NavigationHistoryContext);
